import axios from '../../functions/axios';
import moment from 'moment';
import { useLocation } from 'react-router-dom'
import { useEffect, useState, Navigate,useMemo } from 'react';
import leftArrow from '../../assets/images/selection_left.png';
import rightArrow from '../../assets/images/selection_right.png';
import editButton from '../../assets/images/editButton.png';
import style from './CarriagePaletteList.module.css';
import { useNavigate, Link } from "react-router-dom";
import { useAuthContext } from '../../hooks/useAuthContext';


const parseDate = (date = new Date()) => {
  return {
    week: moment(date).utc().startOf('isoWeek').isoWeek(),
    monthStart: new Date(moment(date).utc().startOf('month').toDate()),
    monthEnd: new Date(moment(date).utc().endOf('month').toDate()),
  };
};

export default function WeekView(props) {
  const [isLoading, setLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const initDate = parseDate(Date.parse(sessionStorage.getItem('selectedMonth') || new Date())).monthStart;
  const [currentDate, setCurrentDate] = useState(initDate);
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchQueryInvoice, setSearchQueryInvoice] = useState('');
  const { user } = useAuthContext();
  const location = useLocation();

  const setMonthDate = (date) => {
    const selectedDate = parseDate(date).monthStart;
    sessionStorage.setItem('selectedMonth', selectedDate);
    setCurrentDate(selectedDate);
  };

  const changeMonth = (offsetMonths) => {
    const date = new Date(currentDate);
    date.setUTCMonth(date.getUTCMonth() + offsetMonths);
    setMonthDate(date);
  };

  const getWidth = (index) => {
    const columnsWidth = [1, 1, 1, 1, 1.5, 1, 1, 1, 1, 1, 1, 1];
    const sum =  columnsWidth.reduce((acc, value) => acc + value, 0);
    return columnsWidth.map(element => (element * 100) / sum)[index];
  };

  const Small = ({ text }) => {
    return <span style={{ fontSize: '.7em' }}>{text}</span>
  }

  const filteredData = useMemo(() => {
    return apiData
      .filter((carriage) => {
        return carriage.invoice?.toLowerCase().includes(searchQueryInvoice.toLowerCase());
      });

  }, [apiData, searchQueryInvoice]);
  const cars = useMemo(() => {
    return [...new Set(filteredData.map((data) => data.car?.plate))].sort((...args) => {
      const [a, b] = args.map((plate) => plate.toUpperCase());
      return a.localeCompare(b, 'pl-PL', { sensitivity: 'base' });
    });
  }, [filteredData]);

  useEffect(() => {
    const source = axios.CancelToken.source();
    (async () => {
      if (!user) return null;
      setLoading(true);
      try {
        const { monthStart, monthEnd } = parseDate(currentDate);
        const response = await axios.get(`/carriage`, {
          params: {
            startDate: monthStart,
            endDate: monthEnd,
            populate: ['car', 'driver', 'paletts', 'client'],
            clientId: location.state?.client?._id,
          },
          cancelToken: source.token,
        });
        setApiData(response.data);
        if (response.data.length) {
          location.state.client = response.data[0].client;
        }
      } catch (error) {
        if (axios.isCancel(error)) {
          console.log('axios request canceled');
          return;
        }
      }
      setLoading(false);
    })();

    return () => {
      source.cancel();
    };
  }, [user, currentDate]);

  const handleFilterInvoice = (event) => setSearchQueryInvoice(event.target.value.trim().replace(/\s+/g, '').toUpperCase());
  const monthDate = ['monthStart', 'monthEnd'].map((day) => new Date(parseDate(currentDate)[day]).toLocaleDateString('pl')).join(' - ');
  const navigation = (
    <div className={style.navigation}>
      <button className={`${style.addReport} btn btn-default`} onClick={navigate.bind(null, '/printPalette', { state: { searchQuery: searchQueryInvoice, client: apiData[0]?.client || location.state?.client || {}} })}>
        Drukuj
      </button>
      <p>{monthDate}</p>
      <img src={leftArrow} onClick={changeMonth.bind(null, -1)} alt='Arrow left' />
      <span className={style.weekNumber} onClick={() => setMonthDate(new Date())}>
        {parseDate(currentDate).monthStart.toLocaleString('pl', { month: 'long' })}
      </span>
      <img src={rightArrow} onClick={changeMonth.bind(null, 1)} alt='Arrow right' />
      <button className={`${style.addCarriage} btn btn-default`} onClick={navigate.bind(null, '/addCarriagePalette', { state: { client: apiData[0]?.client || location.state?.client || {}} })}>
        Dodaj wpis
      </button>
    </div>
  );

  if (isLoading || !apiData.length) {
    return (
      <>
        {navigation}
        <Link to='/carriagePaletteClientsList'><div className={style.contrahent}>Kontrahent: {location.state?.client?.companyName}</div></Link>
        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', fontSize: '1.1em' }}>
          <div>Saldo palet EURO: {apiData[0]?.client?.paletteBallanceE}</div>
          <div>Saldo palet DD: {apiData[0]?.client?.paletteBallanceDD}</div>
        </div>
        {
          !apiData.length
            ? <div className={style.missingData}>Brak danych do wyświetlenia...</div>
            : null
        }
      </>
    );
  }



  return (
    <div className={style.container}>
      {navigation}
      <div className={style.filter}>
            <label>Wyszukaj fakturę:</label>
            <input
              type="search"
              className="form-control"
              placeholder="Faktura"
              value={searchQueryInvoice}
              onChange={(e) => setSearchQueryInvoice(e.target.value)}
            ></input>
          </div>
      <div>
        <Link to='/carriagePaletteClientsList'><div className={style.contrahent}>Kontrahent: {location.state?.client?.companyName}</div></Link>
        <div style={{ display: 'flex', justifyContent: 'space-around', alignItems: 'center', fontSize: '1.1em' }}>
          <div>Saldo palet EURO: {apiData[0]?.client?.paletteBallanceE}</div>
          <div>Saldo palet DD: {apiData[0]?.client?.paletteBallanceDD}</div>
        </div>
      </div>
      <div className={style.mainHeader}>
        <span style={{ minWidth: getWidth(0) + 'vw'}}>Pojazd</span>
        <span style={{ minWidth: getWidth(1) + 'vw'}}>Data</span>
        <span style={{ minWidth: getWidth(2) + 'vw'}}>Faktura</span>
        <span style={{ minWidth: getWidth(3) + 'vw'}}>Kierowca</span>
        <span style={{ minWidth: getWidth(4) + 'vw'}}>Trasa Z/Do</span>
        <span style={{ minWidth: getWidth(5) + 'vw'}}>Wymienione</span>
        <span style={{ minWidth: getWidth(6) + 'vw'}}>Załadowane</span>
        <span style={{ minWidth: getWidth(7) + 'vw'}}>Odebrane</span>
        <span style={{ minWidth: getWidth(8) + 'vw'}}>Zdane</span>
        <span style={{ minWidth: getWidth(9) + 'vw'}}>Saldo</span>
        <span style={{ minWidth: getWidth(10) + 'vw'}}>Kwit</span>
        <span style={{ minWidth: getWidth(11) + 'vw'}}>Edycja</span>
      </div>
      {cars.map((plate) => (
        <div className={style.carWeek} key={plate}>
          <div style={{ minWidth: getWidth(0) + 'vw'}} className={style.plate}>{plate}</div>
          <div className={style.data}>
            {filteredData
              .filter((carriage) => carriage.car.plate === plate)
              .sort((...args) => {
                const [a, b] = args.map(({ day }) => Date.parse(day));
                return a - b;
              })
              .map((carriage) => {
                return (
                  <div className={style.carriageData} key={carriage._id}>
                    <div style={{ minWidth: getWidth(1) + 'vw'}} className={style.route}>
                      {new Date(carriage.day).toLocaleString('pl', { weekday: 'long' })}<br />{new Date(carriage.day).toLocaleDateString('pl')}
                    </div>
                    <div style={{ minWidth: getWidth(2) + 'vw'}} className={style.route}>
                      <div className={style.invoice}>{carriage.invoice || '-'}</div>
                    </div>
                    <div style={{ minWidth: getWidth(3) + 'vw'}}className={style.route}>
                      <div className={style.driver}>{carriage.driver?.name.split(' ').reduce((acc, element) => [acc, <br />, element]) || '-'}</div>
                    </div>
                    <div style={{ minWidth: getWidth(4) + 'vw'}}className={style.route}>
                      <ul className={style.routeTrace}>
                        <li className={style.routeStart}>{carriage.routeStart || '-'}</li>
                        <li className={style.to}>{carriage.routeEnd || '-'}</li>
                      </ul>
                    </div>
                    <div style={{ minWidth: getWidth(5) + 'vw'}}className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteExchanged ? <li className={style.invoice}>{carriage.paletts?.paletteExchanged} <Small text='EUR' /></li> : '-'}
                        {carriage.paletts?.paletteExchangedDD ? <li className={style.invoice}>{carriage.paletts?.paletteExchangedDD} <Small text='DD' /></li> : '-'}
                      </ul>
                    </div>
                    <div style={{ minWidth: getWidth(6) + 'vw'}}className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteLoad ? <li className={style.invoice}>{carriage.paletts?.paletteLoad} <Small text='EUR' /></li> : '-'}
                        {carriage.paletts?.paletteLoadDD ?  <li className={style.invoice}>{carriage.paletts?.paletteLoadDD} <Small text='DD' /></li> : '-'}
                      </ul>
                    </div>
                    <div style={{ minWidth: getWidth(7) + 'vw'}}className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteTaken ? <li className={style.invoice}>{carriage.paletts?.paletteTaken} <Small text='EUR' /></li> : '-'}
                        {carriage.paletts?.paletteTakenDD ? <li className={style.invoice}>{carriage.paletts?.paletteTakenDD} <Small text='DD' /></li> : '-'}
                      </ul>
                    </div>
                    <div style={{ minWidth: getWidth(8) + 'vw'}}className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteLeft ? <li className={style.invoice}>{carriage.paletts?.paletteLeft} <Small text='EUR' /></li> : '-'}
                        {carriage.paletts?.paletteLeftDD ? <li className={style.invoice}>{carriage.paletts?.paletteLeftDD} <Small text='DD' /></li> : '-'}
                      </ul>
                    </div>
                    <div style={{ minWidth: getWidth(9) + 'vw'}}className={style.route}>
                      <ul className={style.routeList}>
                        {carriage.paletts?.paletteBalE ? <li className={style.invoice}>{carriage.paletts?.paletteBalE} <Small text='EUR' /></li> : '-'}
                        {carriage.paletts?.paletteBalDD ? <li className={style.invoice}>{carriage.paletts?.paletteBalDD} <Small text='DD' /></li> : '-'}
                      </ul>
                    </div>
                    <div style={{ minWidth: getWidth(10) + 'vw'}}className={style.route}>
                      {<input id='receipe' type='checkbox' name='receipe' checked={carriage.paletts?.receipe } onChange={() => {}} />}
                    </div>
                    <span className={style.route}>
                      <img className={style.editButton} src={editButton} onClick={() => navigate('/editCarriagePalette', { state: { carriage, client: apiData[0]?.client } })} />
                    </span>
                  </div>
                );
              })
              .reduce((acc, element) => [acc, <hr />, element])
            }
          </div>
        </div>
      ))}
    </div>
  );
}

